<span class="chat-mi-field-label">
  <span class="chat-mi-field-label__name">{{ name }}</span>
  @if (mandatory) {
    <span class="chat-mi-field-label__required" aria-hidden="true">*</span>
  }
  @if (description && description.trim()) {
    <span class="chat-mi-field-label__tip" (mouseleave)="infoTt.close()">
      <span
        class="chat-mi-field-label__info"
        tabindex="0"
        role="img"
        (mouseenter)="infoTt.open()"
        (focus)="infoTt.open()"
        (blur)="infoTt.close()"
        [ngbTooltip]="description"
        [attr.aria-label]="description"
        container="body"
        tooltipClass="chat-mi-info-tooltip"
        #infoTt="ngbTooltip"
      >
        <fa-icon [icon]="faCircleInfo"></fa-icon>
      </span>
    </span>
  }
  @if (locked) {
    <span
      class="chat-mi-field-label__lock"
      i18n-aria-label="@@chatMiDefaultedNotEditable"
      aria-label="Defaulted — not editable"
      role="img"
    >
      <fa-icon [icon]="faLock"></fa-icon>
    </span>
  }
</span>
